import React from "react";
import {Grid} from "@mui/material";
import {TopicsTable} from "../../../modules/TopicsTable";

export default function TopicsTablePage() {

    return (
        <Grid>
            <TopicsTable/>
            {/*<TablePagination count={} page={} onPageChange={} rowsPerPage={} />*/}
        </Grid>
    );
}
